// extracted by mini-css-extract-plugin
export default {"form":"createCategory_form__Qf35P","formInputBlock":"createCategory_formInputBlock__QyDV-","formInput":"createCategory_formInput__QMj19"};